import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKDekontamineringAvRomResultater,
  IGKRapport,
} from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const DekontamineringAvRom: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKDekontamineringAvRomResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Dekontaminering av rom</Title>
        <div className="w-50 mt-4">
          <b>Utført syklus:</b>
          <div>
            <div className="d-flex flex-column">
                            <Radio
                checked={data.inndata.utfoertSyklus === true}
                onChange={() => onUpdateEditData("testResultater.dekontamineringAvRom.inndata.utfoertSyklus", true)}
                label="Utført"
              />
                            <Radio
                checked={data.inndata.utfoertSyklus === false}
                onChange={() => onUpdateEditData("testResultater.dekontamineringAvRom.inndata.utfoertSyklus", false)}
                label="Ikke utført"
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Fyll inn syklusstart (-):"
            value={data.inndata.syklusstart}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.syklusstart", e.target.value)
            }
            type="time"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <McInputNew
            label="Fyll inn syklusslutt (-):"
            value={data.inndata.syklusslutt}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.syklusslutt", e.target.value)
            }
            type="time"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <McInputNew
            label="Fyll inn høyeste PPM (partikler/million):"
            value={data.inndata.hoeyestePPM}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.hoeyestePPM", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <McInputNew
            label="Fyll inn luftfuktighet (%):"
            value={data.inndata.luftfuktighet}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.luftfuktighet", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <McInputNew
            label={<>
              Fyll inn temperatur &#40;C<sup>o</sup>&#41;:
            </>}
            value={data.inndata.temperatur}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.temperatur", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer docxImageTag="dekontamineringAvRom" title="Plassering av sensor" />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.dekontamineringAvRom.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default DekontamineringAvRom;